var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","right":"","color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"text":"","dark":""},nativeOn:{"click":function($event){_vm.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }